var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#69B045",
    d: "M25.834 14.912h-.945c-.069-2.98-1.261-5.772-3.376-7.886-1.82-1.82-4.14-2.956-6.651-3.282.412-.396.668-.952.668-1.568C15.53.974 14.556 0 13.354 0c-1.201 0-2.176.974-2.176 2.176 0 .616.257 1.172.669 1.568-2.51.326-4.832 1.462-6.65 3.282-2.115 2.114-3.308 4.906-3.377 7.886H.876c-.485 0-.876.392-.876.876 0 .483.391.875.876.875H25.834c.483 0 .875-.392.875-.875 0-.484-.392-.876-.875-.876",
    transform: "translate(.13 .018)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#69B045",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M11.993 7.594c-1.548.272-2.961 1.012-4.09 2.14-1.042 1.043-1.76 2.348-2.075 3.777-.09.403-.447.677-.843.677-.062 0-.124-.006-.187-.02-.465-.103-.76-.564-.657-1.029.386-1.75 1.264-3.35 2.542-4.627 1.38-1.38 3.113-2.286 5.013-2.619.47-.083.917.231.999.701.081.47-.232.918-.702 1z",
    transform: "translate(.13 .018)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    d: "M20.345 18.101H2.713c-.253 0-.42.262-.314.492l.712 1.547c.072.155.22.253.385.253h19.717c.164 0 .313-.098.385-.253l.736-1.598c.095-.206-.056-.44-.283-.44h-3.706z",
    transform: "translate(.13 .018)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatering);
export default __webpack_public_path__ + "static/media/catering.0a1b2ddf2910fcf7badccd49678e6d38.svg";
export { ForwardRef as ReactComponent };